import { Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { IDetailTripResponse } from 'src/app/interfaces/Responses/IDetailTripResponse';
import { GeneralService } from 'src/app/services/dashboards/general.service';
import { RealTimeService } from '../../../../services/dashboards/real-time.service';
import { Image } from '../../../../interfaces/Responses/IDetailTripResponse';

@Component({
  selector: 'neoris-trip-detail-real-time',
  templateUrl: './trip-detail-real-time.component.html',
  styleUrls: ['./trip-detail-real-time.component.css']
})
export class TripDetailRealTimeComponent implements OnInit, OnDestroy {


  @ViewChild('image') image: ElementRef
  @ViewChild('pagination') pagination: ElementRef

  @Input() tripID2: string = ''
  responseModal: IDetailTripResponse = null
  @Input() existTrip: boolean = false
  editable: boolean = false
  editPlateForm: UntypedFormGroup

  clientesSubscription: Subscription;
  clientes$: any

  currentIndexImage: number = 0

  allImages: Image[]

  constructor(
    private builder: UntypedFormBuilder,
    private realTimeService: RealTimeService,
    private generalService: GeneralService,
    private renderer: Renderer2,
  ) { }

  ngOnInit(): void {
    this.configForm()
    this.responseModal = null
  }

  configForm() {
    this.editPlateForm = this.builder.group({
      licensePlate: ['']
    })
  }

  

  editPlate(values: any) {
    let licensePlate = values.licensePlate
    let tripid = document.getElementById('tripid').innerHTML
    this.generalService.updatePlateByTripID(tripid, licensePlate).subscribe((r) => {
      if (r.data) {
        document.getElementById('licensePlate').setAttribute('disabled', 'true')
        this.editable = false
        document.getElementById('update-lp').style.display = 'block'
        setTimeout(() => {
          document.getElementById('update-lp').style.display = 'none'
        }, 3000)
      }
    })
  }

  beEditable() {
    document.getElementById('licensePlate').removeAttribute('disabled')
    this.editable = true
  }

  beNotEditable() {
    let platenumber = document.getElementById('platenumber').innerHTML
    let inputValue = <HTMLInputElement>(document.getElementById('licensePlate'))
    inputValue.value = platenumber
    document.getElementById('licensePlate').setAttribute('disabled', 'true')
    this.editable = false
  }

  validate(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode >= 65 && charCode <= 90) return true
    if (charCode >= 97 && charCode <= 122) return true
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  setImage(arg0: number, images: Image[]) {
    if (arg0 !== undefined) this.currentIndexImage = arg0

    document.querySelectorAll('.image-page').forEach(element => {
      element.classList.remove('active')
    })
    document.querySelector(`#image-${this.currentIndexImage}`).classList.add('active')
    this.renderer.setAttribute(this.image.nativeElement, 'src', images[this.currentIndexImage].imagE_URL)
    this.renderer.setAttribute(this.image.nativeElement, 'alt', images[this.currentIndexImage].steP_NAME)
  }

  filterImages(checkPoint: number) {
    this.allImages = JSON.parse(document.getElementById('id-trip').innerHTML).images
    let filterImages = this.allImages.filter(i => i.checkpoinT_ID === checkPoint)
    if (filterImages !== null && filterImages.length > 0) {
      document.getElementById('facilityPoint').innerText = filterImages[0].chekpoinT_NAME
      document.querySelector('.image-container').removeAttribute('style')
      this.setImage(0, filterImages)
    } else {
      document.getElementById('facilityPoint').innerText = 'No hay imágenes para éste punto.'
      document.querySelector('.image-container').setAttribute('style', 'display:none')
      document.querySelector('.pagination').setAttribute('style', 'display:none')
    }
  }

  ngOnDestroy(): void {
    this.existTrip = false
    this.responseModal = null
  }

}
